import React from "react";
import { InsDownloadIconColumn } from "./columns/insDownloadIconColumn";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { language } from "language/default";
const lang = language.en.administration.dataAdministration.exportData;
export const useHistoryDataExportGridColumns = () => [
    { field: "Id", hide: true, lockVisible: true },
    {
        cellRenderer: (params) => {
            const id = params.data.Id;
            return React.createElement(InsDownloadIconColumn, { id: id });
        },
        headerName: "Download",
        type: [CustomColumnType.InsCenterAllignedColumn],
        width: 80
    },
    { field: "Name", headerName: lang.columns.name, type: CustomColumnType.InsTextSetColumn, width: 280 },
    { field: "ExportDate", headerName: lang.columns.exportDate, sort: "desc", type: CustomColumnType.InsDateTimeColumn, width: 180 },
    { field: "Description", headerName: lang.columns.description, type: CustomColumnType.InsTextSetColumn, width: 280 }
];
